import Page from "@app/components/pageTypes/Page/Page"

import MyParadiseEmployeePoints from "@app/components/myParadise/MyParadiseOverviewEntries/MyParadiseEmployeePoints"
import "./styles.css"

export default function AppEmployeePointsPage() {
	return (
		<Page className="appdataPage">
			<MyParadiseEmployeePoints />
		</Page>
	)
}
